import styled from '@emotion/styled';
import { LeaguePreviewWrapper } from '@seedlang/hoc';
import { AppUI } from '@seedlang/state';
import { flexCenterColumn } from '@seedlang/style_mixins';
import { isBlank } from '@seedlang/utils';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import Spinner from 'components/spinner';
import { observer } from 'mobx-react';
import React from 'react';
import { Link } from 'react-router';
import LeagueBadgeIcon from './league_badge_icon';

const Wrapper = styled.div`
  ${flexCenterColumn()}
  width: 100%;
`;

const IconWrapper = styled.div`
  position: relative;
  cursor: ${props => props.cursor || 'pointer'}
  z-index: 1;
`;

const SpinnerWrapper = styled.div`
  z-index: 2;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.5;
`;

const LeagueTitle = styled.div`
  display: block;
  width: 100%;
  text-align: center;
  font-size: 13px;
  line-height: 18px;
  font-weight: bold;
  color: #000;
  margin-top: 10px;
  text-transform: uppercase;
`;

const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 10px;
  position: relative;
`;

const Result = styled.div`
  padding: 10px 20px;
  position: relative;
  font-size: 14px;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  text-align: center;
  flex-direction: column;
`;

@observer
class LeaguePreview extends React.Component {
  static defaultProps = {
    padding: '0',
  }

  render() {
    return (
      <Wrapper>
        <ImageContainer>
          {
            this.props.user?.currentLeague &&
            <Link
              to={{
                name: 'league.show',
                params: {
                  leagueId: this.props.user.currentLeague.id,
                  userId: this.props.user.id,
                },
              }}
            >
              <IconWrapper>
                {
                  AppUI.authUserStore.requestCounter > 0 &&
                  <SpinnerWrapper>
                    <Spinner height='10px' background='#FFF' margin="5px" />
                  </SpinnerWrapper>
                }
                <LeagueBadgeIcon
                  showRank
                  showIcon={this.props.user?.currentLeague?.ended}
                  leagueLevelPosition={AppUI.user?.currentLeague?.leagueLevel?.position}
                  rank={AppUI.user?.currentUserLeague?.rank}
                  promotionStatus={AppUI.user?.currentUserLeague?.promotionStatus}
                  borderColor='#FFF'
                />
              </IconWrapper>
            </Link>
          }
          {
            !this.props.user?.currentLeague &&
            <IconWrapper
              cursor='default'
            >
              <LeagueBadgeIcon
                leagueLevelPosition={0}
              />
            </IconWrapper>
          }
        </ImageContainer>
        {
          this.props.user?.currentLeague && !this.props.user?.currentLeague.ended &&
            <LeagueTitle>
              {this.props.user?.currentLeague?.leagueLevel?.name}
            </LeagueTitle>
        }
        {
          isBlank(this.props.user?.currentLeague) &&
            <Result>
              Start Learning to Join a League
            </Result>
        }
        {
          this.props.user?.currentLeague?.ended &&
            <Result>
              <div>{`You finished #${AppUI.user?.currentUserLeague?.rank} in`}</div>
              <div>the <b>{this.props.user?.currentLeague?.leagueLevel?.name}</b></div>
            </Result>
        }
      </Wrapper>
    );
  }
}

export default ErrorBoundary(LeaguePreviewWrapper(LeaguePreview));
